export default __webpack_public_path__ + "static/media/PreviewA5.9df5f945.png";